import { ReactElement } from "react";
import { IEAF, IPanelProps } from "./types";
import RowComponent from "../../components/rowComponent";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import TextField from "@mui/material/TextField";
import { cloneObject } from "../../../../system/utils";

const EAFPanel = ({ value, property, onChange }: IPanelProps<IEAF>): ReactElement => {

  const onChangeValue = (prop: keyof IEAF, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof IEAF, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Baghouse" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.bagHouse.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("bagHouse", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.bagHouse.comment}
            fullWidth={true}
            onChange={event => onChangeComment("bagHouse", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="B3 ratio (<1.6 or >1.9)" ratio={.2} >
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.b3Ratio.value}
            fullWidth={true}
            onChange={event => onChangeValue("b3Ratio", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.b3Ratio.comment}
            fullWidth={true}
            onChange={event => onChangeComment("b3Ratio", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="MgO" ratio={.2} >
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.mgO.value}
            fullWidth={true}
            onChange={event => onChangeValue("mgO", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.mgO.comment}
            fullWidth={true}
            onChange={event => onChangeComment("mgO", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="FeO" ratio={.2} >
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.feO.value}
            fullWidth={true}
            onChange={event => onChangeValue("feO", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.feO.comment}
            fullWidth={true}
            onChange={event => onChangeComment("feO", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default EAFPanel;